import {
  Text,
  Box,
  Image,
  ListItem,
  theme,
  Flex,
  List,
  Heading,
  Icon,
} from '@everlywell/ui-kit';
import { CheckCircle, XCircle } from '@phosphor-icons/react';
import React from 'react';

export type ComparisonMarker = {
  name: string;
  isExcluded?: boolean;
};

export type MarkerCategory = {
  title: string;
  markers: ComparisonMarker[];
  image?: any;
};

export type ListOfComparisonItemsProps = {
  markerCategoryList: MarkerCategory[] | null;
};

export const ListOfComparisonItems = ({
  markerCategoryList,
}: ListOfComparisonItemsProps) => (
  <Box>
    {markerCategoryList?.map((markerCategory) => {
      const notExcludedCount = markerCategory.markers.filter(
        (marker) => !marker.isExcluded,
      ).length;

      return (
        <Box key={markerCategory.title} marginBottom={10}>
          <Flex
            flexDirection="row"
            marginBottom="3"
            gap="2"
            justifyContent="space-between"
            alignItems="center"
          >
            <Flex gap="2" alignItems="center">
              <Image
                boxSize={theme.fontSizes['3xl']}
                aria-hidden="true"
                src={markerCategory.image}
              />
              <Heading fontSize={['lg', '2xl']} as="h3">
                {markerCategory.title}
              </Heading>
            </Flex>
            <Box>
              <Text fontSize="2xl" color="viridian.base">
                {notExcludedCount}
              </Text>
            </Box>
          </Flex>
          <List display="flex" flexDirection="column" gap="4">
            {markerCategory.markers.map((marker) => (
              <ListItem
                key={marker.name}
                fontWeight="light"
                display="flex"
                gap="2"
                alignItems="center"
                color={marker.isExcluded ? 'tints.medGrey' : undefined}
              >
                <Icon
                  as={marker.isExcluded ? XCircle : CheckCircle}
                  color={marker.isExcluded ? 'tints.medGrey' : 'viridian.base'}
                  height="24px"
                  width="24px"
                  weight="fill"
                />
                {marker.name}
              </ListItem>
            ))}
          </List>
        </Box>
      );
    })}
  </Box>
);

export default ListOfComparisonItems;
